import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ChevronLeftIcon, ChevronRightIcon} from '@/components/ui/icon/Icon'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import {formatLocaleDate} from '@/dayjs'
import {useTranslation} from '@/translations/i18n'
import {useAgendaNavigation} from '../../hooks/useAgendaNavigation'
import {StyledCurrentDateTitle} from './style'

dayjs.extend(weekday)

export const AgendaToolbarHandler = () => {
    const {t} = useTranslation()
    const {params, goToNextPeriod, goToPreviousPeriod, goToToday} = useAgendaNavigation()

    const renderDateTitle = () => {
        const currentDate = dayjs(params.date)
        if (params.view == 'week') {
            const startOfWeek = currentDate.startOf('week')
            const endOfWeek = currentDate.endOf('week').subtract(1, 'day')

            const startFormatted = formatLocaleDate(startOfWeek.toDate(), 'll')
            const endFormatted = formatLocaleDate(endOfWeek.toDate(), 'll')

            return `${startFormatted} - ${endFormatted}`
        }

        if (params.view == 'month') {
            return formatLocaleDate(params.date, 'MMMM YYYY')
        }

        if (params.view == 'agenda') {
            const startFormatted = formatLocaleDate(currentDate.toDate(), 'll')
            const endOfMonth = currentDate.endOf('month')
            const endFormatted = formatLocaleDate(endOfMonth.toDate(), 'll')

            return `${startFormatted} - ${endFormatted}`
        }

        return formatLocaleDate(params.date, 'dddd LL')
    }

    return (
        <Flexbox gap={4} align="center" fullWidth>
            <Flexbox gap={2} align="center">
                <Button variant="secondary" shape="square" onClick={goToPreviousPeriod}>
                    <ChevronLeftIcon />
                </Button>
                <Button variant="secondary" shape="square" onClick={goToNextPeriod}>
                    <ChevronRightIcon />
                </Button>
                <Button variant="secondary" onClick={goToToday}>
                    {t('range_date:today')}
                </Button>
            </Flexbox>
            <StyledCurrentDateTitle>{renderDateTitle()}</StyledCurrentDateTitle>
        </Flexbox>
    )
}
